<div class="sr-shell">

  <!-- ── Header ──────────────────────────────────────────────────────────── -->
  <div class="sr-head">
    <div class="sr-head__tile">
      <lucide-icon name="bell" [size]="16"></lucide-icon>
    </div>
    <div class="sr-head__copy">
      <div class="sr-head__title">{{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_REMINDER.TITLE' | translate }}</div>
      <div class="sr-head__sub" *ngIf="displayName">
        Para <strong>{{ displayName }}</strong>
      </div>
    </div>
    <button type="button" class="sr-head__close" (click)="cancel()">
      <lucide-icon name="x" [size]="15"></lucide-icon>
    </button>
  </div>

  <!-- ── Body ────────────────────────────────────────────────────────────── -->
  <div class="sr-body">

    <p class="sr-intro">
      {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_REMINDER.INTRO' | translate }}
    </p>

    <div class="sr-channels-label">
      {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_REMINDER.CHANNELS_LABEL' | translate }}
      <span class="sr-required">*</span>
    </div>

    <!-- SMS channel card -->
    <div class="sr-channel-card" [class.is-selected]="smsSelected" (click)="toggleSms()" *ngIf="sms">
      <div class="sr-channel-card__icon">
        <lucide-icon name="message-circle" [size]="14"></lucide-icon>
      </div>
      <div class="sr-channel-card__info">
        <span class="sr-channel-card__name">SMS</span>
        <span class="sr-channel-card__address">{{ sms }}</span>
      </div>
      <div class="sr-check" [class.is-checked]="smsSelected"></div>
    </div>

    <!-- Email channel card -->
    <div class="sr-channel-card" [class.is-selected]="emailSelected" (click)="toggleEmail()" *ngIf="email">
      <div class="sr-channel-card__icon">
        <lucide-icon name="mail" [size]="14"></lucide-icon>
      </div>
      <div class="sr-channel-card__info">
        <span class="sr-channel-card__name">Email</span>
        <span class="sr-channel-card__address">{{ email }}</span>
      </div>
      <div class="sr-check" [class.is-checked]="emailSelected"></div>
    </div>

    <!-- Summary -->
    <div class="sr-summary" *ngIf="canSend">
      <lucide-icon name="info" [size]="13"></lucide-icon>
      <span>
        <ng-container *ngIf="smsSelected && emailSelected">
          Se enviará por <strong>SMS</strong> a <strong>{{ sms }}</strong> y por <strong>Email</strong> a <strong>{{ email }}</strong>.
        </ng-container>
        <ng-container *ngIf="smsSelected && !emailSelected">
          Se enviará por <strong>SMS</strong> a <strong>{{ sms }}</strong>.
        </ng-container>
        <ng-container *ngIf="!smsSelected && emailSelected">
          Se enviará por <strong>Email</strong> a <strong>{{ email }}</strong>.
        </ng-container>
      </span>
    </div>

  </div>

  <!-- ── Footer ──────────────────────────────────────────────────────────── -->
  <div class="sr-footer">
    <button type="button" class="sr-btn sr-btn-text" (click)="cancel()">
      {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_REMINDER.CANCEL' | translate }}
    </button>
    <pay-button
      [label]="'DATA.MODULES.SHARED.COMPONENTS.SEND_REMINDER.SEND_BTN' | translate"
      variant="primary"
      [disabled]="!canSend"
      (clicked)="send()"
    ></pay-button>
  </div>

</div>
